import React from 'react'
import { CircularProgressbar } from 'react-circular-progressbar';
import "react-circular-progressbar/dist/styles.css";
import { Container } from './index.style';

function CircProgressBarComponent({width = 80, trackColor = '#000000', progressColor = '#FFF', value = 1}) {
  return (
    <Container width={width} trackColor={trackColor} progressColor={progressColor}>
      <CircularProgressbar
        value={value}
        strokeWidth={2}
      />
    </Container>
  )
}

export default React.memo(CircProgressBarComponent);
